import { Pipe, PipeTransform } from '@angular/core';
import { LessonPageItem } from '../../data/models/LessonPageItem';
import { LessonPageItemTypeEnum } from '../../data/enums/LessonPageItemType';

@Pipe({
  name: 'filterVideoType',
  standalone: true
})
export class FilterVideoTypePipe implements PipeTransform {
  transform(items: LessonPageItem[] | null): LessonPageItem[] {
    if (!items) return [];
    return [...items.filter(item => item.type?.title === 'Video' && item.videoData)];
  }
}
